import { __assign, __rest } from "tslib";
import { TableCell as MUTableCell, createStyles, makeStyles, } from '@material-ui/core';
import React from 'react';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        head: {
            backgroundColor: 'transparent',
            borderBottomWidth: 0,
            fontWeight: 'bold',
            fontSize: theme.typography.fontSize,
            color: theme.palette.secondary.dark,
        },
        body: {
            fontSize: theme.typography.fontSize,
            backgroundColor: 'transparent',
            borderBottomColor: theme.palette.grey['200'],
        },
    });
});
export var TableCell = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classes = useStyles();
    return (React.createElement(MUTableCell, __assign({ classes: classes }, props), children));
};
//# sourceMappingURL=TableCell.js.map